<i18n lang="yaml">
ru:
  select_delivery_address: 'Выберите способ доставки'
  pickup: 'Самовывоз'
  delivery: 'Доставка'
  from: 'с'
  stock_address: 'Адрес склада:'
  working_hours: 'Режим работы:'
  show_map: 'Посмотреть карту'
  change_address_request: 'Отправить запрос на изменение адреса'
  stock: 'Склад'
  yandex_maps: 'Яндекс Карты'
en:
  select_delivery_address: 'Select delivery method'
  pickup: 'Pickup'
  delivery: 'Delivery'
  from: 'from'
  stock_address: 'Stock address:'
  working_hours: 'Working hours:'
  show_map: 'View on map'
  change_address_request: 'Send delivery address change request'
  stock: 'Stock'
  yandex_maps: 'Yandex Maps'
</i18n>

<template>
  <div class="delivery">
    <div class="container delivery-container">
      <div class="h4">{{ $t('select_delivery_address') }}</div>
      <h3>{{ $t('select_delivery_address') }}</h3>
      <div class="delivery-buttons">
        <div class="radiobutton">
          <input 
            class="styled-radiobutton"
            id="radiobutton-pickup"
            type="radio"
            @click="setDeliveryMethod(true)"
            :checked="selfDelivery"
          />
          <label for="radiobutton-pickup" class="radio-label">{{ $t('pickup') }}</label>
          <div class="date-delivery">
            <span class="date">{{ $t('from') }} {{ stock.shipment_days | shipmentDate($i18n.locale) }}</span>
          </div>
          <transition name="fadeHeight" mode="out-in">
            <div v-if="selfDelivery" class="pickup-date">
              <div class="address" v-if="stockContactLocaleData.address">
                <span>{{ $t('stock_address') }}</span>
                <span>{{ stockContactLocaleData.address }}</span>
              </div>
              <div class="time" v-if="stockContactLocaleData.working_hours">
                <span>{{ $t('working_hours') }}</span>
                <span>{{ stockContactLocaleData.working_hours }}</span>
              </div>
              <div class="map">
                <a @click="showMapModal=true">{{ $t('show_map') }}</a>
              </div>
            </div>
          </transition>
        </div>

        <div class="radiobutton" v-if="$auth.loggedIn && $auth.user.user_addresses && $auth.user.user_addresses.length">
          <input
            class="styled-radiobutton" 
            id="radiobutton-address1"
            type="radio"
            @click="setDeliveryMethod(false)"
            :checked="selfDelivery === false"
          />
          <label for="radiobutton-address1" class="radio-label">{{ $t('delivery') }}</label>
          <div class="date-delivery">
            <span class="date">{{ $t('from') }} {{ stock.shipment_days | shipmentDate($i18n.locale) }}</span>
          </div>
          <transition name="fadeHeight" mode="out-in">
            <div v-if="selfDelivery === false" class="delivery-date">
              <div v-for="address in $auth.user.user_addresses" :key="address.id" class="address">
                <div class="radiobutton">
                  <input
                    class="styled-radiobutton"
                    :id="`delivery-date-` + address.id"
                    type="radio"
                    :value="address.id"
                    :checked="deliveryAddress === address.id"
                    @click="setDeliveryAddress(address.id)"
                  />
                  <label :for="`delivery-date-` + address.id" class="radio-label">{{ address.address }}</label>
                </div>
                <div class="address-request">
                  <input
                    class="styled-radiobutton"
                    :id="`delivery-date-` + 0"
                    type="radio"
                    :value="0"
                    :checked="deliveryAddress === 0"
                  />
                  <label :for="`delivery-date-` + 0" class="radio-label" />
                  <a href="#" @click.prevent="sendChangeDeliveryAddress">{{ $t('change_address_request') }}</a>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <modal-map :visible="showMapModal" @close="showMapModal = false">
      <template #header>
        <h3>{{ $t('stock') }}</h3>
      </template>
      <template #body>
        <div style="position:relative;overflow:hidden;">
          <a
            :href="stockContactLocaleData.yandex_map"
            style="color:#eee;font-size:12px;position:absolute;top:14px;"
          >{{ stockContactLocaleData.address }} — {{ $t('yandex_maps') }}</a>
          <iframe
            :src="stockContactLocaleData.yandex_map?.replace('https://yandex.ru/maps/', 'https://yandex.ru/map-widget/v1/')"
            width="1200"
            height="530"
            frameborder="1"
            allowfullscreen="true"
            style="position:relative;"
          />
        </div>
      </template>
      <template #footer>
        <div />
      </template>
    </modal-map>

    <!-- <change-delivery-address ref="change_delivery_address" /> -->
  </div>
</template>

<script>

import ChangeDeliveryAddress from '@/components/profile/change-delivery-address';
import ModalMap from '@/components/modal-map';

export default {
  components: {
    ChangeDeliveryAddress,
    ModalMap,
  },
  props: [
    'selfDelivery',
    'deliveryAddress',
    'stock'
  ],
  data() {
    return {
      showMapModal: false,
    }
  },
  computed: {
    stockContactLocaleData() {
      return this.stock?.stock_contact?.stock_contact_translations?.find(x => x.language.slug === this.$i18n.locale) || {};
    },
  },
  methods: {
    setDeliveryMethod(value) {
      this.$emit('set-delivery-method', value);
      if (value) {
        this.setDeliveryAddress(null);
      }
    },
    setDeliveryAddress(value) {
      this.$emit('set-delivery-address', value);
    },
    sendChangeDeliveryAddress() {
      this.$refs.change_delivery_address.submit();
    },
  },
}
</script>
